var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilledWhiteSuccessIcon = function SvgFilledWhiteSuccessIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.31 7.166a5.143 5.143 0 1 0-10.286 0 5.143 5.143 0 0 0 10.286 0Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.167 1.168a6.01 6.01 0 0 0-6 6c0 3.306 2.694 6 6 6s6-2.694 6-6-2.694-6-6-6Zm2.868 4.62L6.633 9.19a.45.45 0 0 1-.636 0L4.299 7.492a.453.453 0 0 1 0-.636.453.453 0 0 1 .636 0l1.38 1.38 3.084-3.084a.453.453 0 0 1 .636 0 .453.453 0 0 1 0 .636Z",
    fill: "#06C270"
  })));
};
export default SvgFilledWhiteSuccessIcon;